export default __webpack_public_path__ + "static/media/prescribedMedication.a97fb18e.svg";